import { BrandsIcon } from '../icons'

export const HowDoesItWork: React.FC = () => {
	return (
		<div className='how-does-it-work'>
			<section className='content'>
				<h1>How does it work?</h1>
				<p>
					By watching the video below, you can have a short training and learn
					about how the application works.
				</p>
			</section>
			<section className='iframe-container'>
				<iframe
					title='avideo'
					src='https://www.youtube.com/embed/tgbNymZ7vqY'></iframe>
			</section>
			<section className='button-section'>
				<button>
					<div>
						<BrandsIcon />
					</div>{' '}
					Brands
				</button>
			</section>
		</div>
	)
}
